















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { deleteElement } from "@/api/delite/delite-element";
import { gallerys } from "@/config/host.config";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import ContextMenu from "@/components/buttons/context-menu.vue";

import { IPhotoFormat } from "@/@types/gallsery/gallery";

@Component({ components: { InputSearch, ChangeDeliteButtons, ContextMenu } })
export default class GalleryFormatList extends Vue {
  @Prop({ type: Array, default: () => [] }) formatList!: Array<IPhotoFormat>;
  search = "";
  openFormat: string | undefined = "";
  constxtID = "";

  $refs!: {
    menu: ContextMenu;
  };

  get formats(): Array<IPhotoFormat> {
    return this.formatList.filter((item) => {
      return (
        this.$getLocale(item.name)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) > -1
      );
    });
  }

  changeElement(id: string, type: boolean): void {
    if (type == true) {
      this.$emit("changeFormat", id);
      return;
    }
    const uri = gallerys.formats;
    deleteElement(id, uri)
      .then(() => {
        this.$emit("deleteFormat", id);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  handler(e: PointerEvent, id: string | undefined): void {
    e.preventDefault();
    if (!id) return;
    this.$nextTick(() => {
      this.$refs.menu.contextX = e.clientX;
      this.$refs.menu.contextY = e.clientY;
      this.$refs.menu.showContext = true;
      this.constxtID = id;
    });
  }
}
